import React from "react";

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

class Copyright extends React.Component{

    render() {
        return (
            <Typography variant="body2" color="text.secondary" align="center" {...this.props}>
                {'Copyright © '}
                <Link color="inherit" href="https://valucadi.com/">
                    Valucadi
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
          </Typography>
        );
    }
}

export default Copyright